import { FormattedMessage } from 'react-intl';
import {
    PoolButton,
    PoolModal,
    PoolModalActions,
    PoolModalContent,
    PoolModalTitle,
    PoolTextfield,
} from '@synergy/components-next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
    bonusSettlementDetailReadOnlySelector,
    bonusSettlementDetailSelector,
} from '../store/bonus-settlements-detail-selector';
import { updateNoteFromSupplier } from '../store/bonus-settlements-detail-actions';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

interface BonusSettlementDetailCommentModalProps {
    open: boolean;
    onClose: () => void;
    translationId: string;
}

export const BonusSettlementDetailCommentModal = (props: BonusSettlementDetailCommentModalProps) => {
    const { open, onClose, translationId } = props;
    const dispatch = useAppDispatch();
    const readOnly = useAppSelector(bonusSettlementDetailReadOnlySelector);
    const bonusSettlementDetail = useAppSelector(bonusSettlementDetailSelector);
    const [comment, setComment] = useState(bonusSettlementDetail?.noteFromSupplier ?? '');
    const { id: bonusSettlementId } = useParams();

    const handleSave = () => {
        if (!bonusSettlementId) {
            return;
        }

        dispatch(updateNoteFromSupplier({ bonusSettlementId: +bonusSettlementId, note: comment }));
        onClose();
    };

    // FIXME somehow the initial value always stays empty if this useEffect is not called
    useEffect(() => {
        if (bonusSettlementDetail?.noteFromSupplier !== undefined) {
            setComment(bonusSettlementDetail.noteFromSupplier);
        }
    }, [bonusSettlementDetail]);

    return (
        <PoolModal open={open} onClose={onClose}>
            <PoolModalTitle>
                <FormattedMessage id={translationId} />
            </PoolModalTitle>
            <PoolModalContent>
                <PoolTextfield
                    value={comment}
                    onChange={e => setComment(e.target.value.slice(0, 400))}
                    label={<FormattedMessage id="app.bonusSettlements.supplierDetail.comment" />}
                    fullWidth={true}
                    multiline={true}
                    rows={3}
                    disabled={readOnly}
                    hint={
                        <FormattedMessage
                            id="app.common.characterLimit"
                            values={{ value: comment.length ?? 0, total: 400 }}
                        />
                    }
                />
            </PoolModalContent>
            <PoolModalActions>
                <PoolButton variant="outlined" onClick={onClose}>
                    <FormattedMessage id="app.common.close" />
                </PoolButton>
                <PoolButton onClick={handleSave} disabled={readOnly || comment.length === 0}>
                    <FormattedMessage id="app.common.save" />
                </PoolButton>
            </PoolModalActions>
        </PoolModal>
    );
};
